

import loading from "@/components/public-components/loading/index.vue";

import goBack from "@/components/public-components/goBack/index.vue";
import { Dialog } from 'vant';
import bus from "@/javascript/bus";
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Toast from 'vux/src/components/toast/index.vue'


export default {
components: {
Group,
Cell,
XInput,
XButton,
XSwitch,
Toast,

loading,

goBack,
},
data() {
return {
minHeight: 0,
userInfo: bus.userInfo.user,
token: bus.userInfo.access_token,
userConfig: bus.userConfig || {},
toast: {
text: "",
show: false,
},
maxSize: 10,
avatar: {},
showCover: true,
getUserName: "",

maxLength: 12,
};
},
computed: {
headImage: function () {
if (this.userInfo.avatar) {
if (this.userInfo.avatar.indexOf("http://") === -1) {
return this.PIC_BASE_URL + this.userInfo.avatar;
} else {
return this.userInfo.avatar;
}
} else {
return require("../../../assets/public-img/center_icon00.png");
}
},
},
created() {
this.$http
.get(
"/api/wtcp-member/public/setup/findByUserId?access_token=" +
bus.userInfo.access_token +
"&userId=" +
bus.userInfo.user.id
)
.then((response) => {
const userConfig = response.data.data;
this.userConfig = userConfig || {};

if (!userConfig) {
this.$http
.get(
"/api/wtcp-member/public/setup/findByUserId?access_token=" +
bus.userInfo.access_token +
"&userId=" +
bus.userInfo.user.id
)
.then((response) => {});
}
});
},
mounted() {
const _this = this;
document.title = _this.PAGE_TITLE + "我的设置";
_this.minHeight = document.documentElement.clientHeight;

_this.$http
.get(
"/api/wtcp-oauth/public/publicuser/" +
bus.userInfo.user.id +
"?access_token=" +
bus.userInfo.access_token
)
.then((response) => {
_this.$set(this, "userInfo", response.data.data);
_this.getUserName = response.data.data.nickname
? response.data.data.nickname
: "";
});

setTimeout(function () {
_this.showCover = false;
}, 250);


},
methods: {
validateString(str, maxLength) {

if (str.length > maxLength) {
return false;
}

return true;
},
goCenter: function () {
this.$router.push({ path: "/center" });
},
save() {
const _this = this;

if (!this.validateString(_this.getUserName,this.maxLength)) {
Dialog.alert({
title: "提示",
message: "昵称不能超过12个字符",
}).then(() => {

})
return
}
let param = {
id: _this.userInfo.id,
name: _this.userInfo.name,
nickname: _this.getUserName,
username: bus.userInfo.user.username,
phone: _this.userInfo.mobile ? _this.userInfo.mobile : _this.userInfo.phone,
avatar: _this.userInfo.avatar,
token: _this.token,
};
_this.$http
.put(
"/api/wtcp-oauth/public/publicuser/" +
bus.userInfo.user.id +
"?access_token=" +
param.token,
param
)
.then((response) => {
const resData = response.data;
if (resData.status === 1) {
_this.toast.text = "更改成功";
_this.toast.show = true;
_this.$http
.get(
"/api/wtcp-oauth/public/publicuser/" +
bus.userInfo.user.id +
"?access_token=" +
bus.userInfo.access_token
)
.then((response) => {
console.log("获取用户信息-mounted", response.data);
});
setTimeout(function () {
_this.goCenter();
}, 3000);
}
});
},
logout() {
this.$http
.delete("/api/wtcp-oauth/revokeToken?access_token=" + bus.userInfo.access_token)
.then((response) => {
const resData = response.data;
if (resData.msg === "success") {
bus.$set(bus, "userInfo", {});
bus.$set(bus, "userConfig", {});
localStorage.removeItem("userInfo");
localStorage.removeItem("wxUserInfo");
this.$router.push({ name: "home" });
}
});
},
chooseAvatar() {
document.getElementById("upload_file").click();
},
fileChange(el) {
if (!el.target.files[0].size) return;
const file = el.target.files[0];
if (file.size > 1024000 * this.maxSize) {
this.toast.text = "图片不能大于" + this.maxSize + "M";
this.toast.show = true;
return;
}
this.fileAdd(file);
el.target.value = "";
},
fileAdd(file) {
if (this.limit !== undefined) this.limit--;
if (this.limit !== undefined && this.limit < 0) return;

this.size = this.size + file.size;

if (file.type.indexOf("image") == -1) {
this.toast.text = "请选择图片文件";
this.toast.show = true;
} else {
const reader = new FileReader(),
image = new Image(),
_this = this;
reader.readAsDataURL(file);
reader.onload = function () {
file.src = this.result;

const config = {
headers: {
"Content-Type": "multipart/form-data;boundary = " + new Date().getTime(),
},
};


const postData = {
base64Code: file.src,
format: file.type.split("/")[1],
};
_this.$http
.post(
"/api/zuul/wtcp-material/uploads/base64ToImg/toc/" + _this.userInfo.id,
postData
)
.then((response) => {
if (response.data.status === 1) {
const avatarData = response.data.data;
_this.userInfo.avatar = avatarData.filePath;
} else {
_this.toastText = "头像上传失败";
_this.toastShow = true;
}
});
};
}
},
saveConfig() {






















this.userConfig.isPush = this.userConfig.isPush === 0 ? 1 : 0;
const param = this.userConfig;
console.log("this.", new Date().getTime());
param.token = bus.userInfo.access_token;

const setupEntity = {
createdDate: new Date().getTime(),
id: "",
isFind: 1,
isHistory: 1,
isPush: this.userConfig.isPush,
updatedDate: new Date().getTime(),
userId: bus.userInfo.user.id,
username: bus.userInfo.user.username,
};

this.$http
.put(
"/api/wtcp-member/public/setup/" +
bus.userInfo.user.id +
"?access_token=" +
param.token,
setupEntity,
{
headers: {
"Content-Type": "application/json",
},
}
)
.then((response) => {
const resData = response.data;
if (resData.status === 1) {
this.toast.text = "消息关闭成功";
this.toast.show = true;
}
});
},
},
};
